/// <reference path="../../../../app.definition.ts" />

import * as angular from 'angular';
import 'angular-ui-bootstrap';
import _ from 'lodash';
import * as toastr from 'toastr';
import * as jsonLogic from 'json-logic-js';
import { StateService, StateParams } from '@uirouter/angularjs';
import { IAppRootScopeService } from '@/app/app.definition';
import { JavaApiAdapterService } from '@common/apiadapter/javaapi.service';
import { FieldTypeEnum, DataTypeEnum, FieldCategoryEnum, ReportMaster } from '@common/model/analytics.model';
import { BroadcastService } from '@common/service/broadcast.service';
import { CacheService } from '@common/service/cache.service';
import { ExtModuleService } from '@common/service/extrnlModule.service';
import { FieldService } from '@common/service/field.service';
import { IUtilityService } from '@common/service/util.service';
import { Util } from '@common/util';


interface IEcvViewReport {
    extrnlModule: boolean;
    params: any;
    init(): void;
    isPopup: boolean;
}

class EcvViewReport implements IEcvViewReport {
    static $inject = ["$scope", "$filter", "FieldService", "$uibModal", "$q", "$state",
        "$stateParams", "$rootScope", "$timeout", "CacheService", "ApiAdapterService",
        "BroadcastService", "ExtModuleService", "UtilityService"];
    settings: object;
    fields: any;
    filters: any;
    iFieldKeys: any;
    filterKeys: any;
    extrnlModule: boolean;
    fieldsCopy: any;
    showFilter: any;
    openGenerateReportPopup: any;
    init: any;
    params: any;
    subjectId;
    isPopup: boolean;
    ecvId;
    chartState;
    initParams = {}
    constructor(
        $scope: angular.IScope,
        $filter: angular.IFilterService,
        FieldService: FieldService,
        $uibModal: angular.ui.bootstrap.IModalService,
        $q: angular.IQService,
        $state: StateService,
        $stateParams: StateParams,
        $rootScope: IAppRootScopeService,
        $timeout: angular.ITimeoutService,
        CacheService: CacheService,
        ApiAdapterService: JavaApiAdapterService,
        BroadcastService: BroadcastService,
        ExtModuleService: ExtModuleService,
        $util: IUtilityService
    ) {

        // initializing vars
        const vrdVm: any = this;
        let print = $rootScope.print;
        vrdVm.fieldType = FieldTypeEnum;
        vrdVm.chartState = [];

        BroadcastService.registerCallBack('chart-data-loaded', $scope.$id, () => {
            vrdVm.loadedChartCount++;
            if (vrdVm.dataViewConfig.charts.length == vrdVm.loadedChartCount && !!vrdVm.isPrintInProgress) {
                const printContainer = $('#printContainer');
                printContainer.children().remove();
                $timeout(() => {
                    const cmg = $('#chartMsgCntnr');
                    const cmg1 = cmg.clone();
                    const numCanvas = cmg1.find('canvas').length;
                    let loadedNumImgs = 0;

                    const printContent = () => {
                        printContainer.append(cmg1);
                        let timeout = isIE11 ? 1000 : 0;
                        $timeout(() => {
                            $util.printLayout('landscape');
                            print();
                            vrdVm.isPrintInProgress = false;
                            vrdVm.loadedChartCount = 0;
                        }, timeout);
                        BroadcastService.broadcast('print-completed');
                    }
                    const onImageLoad = function () {
                        loadedNumImgs++;
                        if (loadedNumImgs == numCanvas) {
                            printContent();
                        }
                    }
                    if (numCanvas > 0) {
                        cmg.find('canvas').each(function () {
                            const canvas = this as HTMLCanvasElement;
                            const img = document.createElement('img');
                            img.style.width = canvas.width + 'px';
                            img.style.height = canvas.height + 'px';
                            img.src = canvas.toDataURL();

                            const parentId = $(this).parent().parent().attr('id');
                            const cmg1ChartParent = cmg1.find('#' + parentId);
                            const c = cmg1ChartParent.find('canvas');
                            const tileData = cmg1ChartParent.siblings('.tiledata');
                            const applyBg = function (elm) {
                                const bgc = elm.css('background-color');
                                elm.attr('style', 'background-color: ' + Util.getRGBToHex(bgc) + ' !important');
                            }
                            tileData.find('.tile').each(function () {
                                applyBg($(this));
                            });
                            const tooltip = $(canvas).parent().siblings();
                            if (tooltip.length > 0) {
                                applyBg(tooltip);
                            }
                            img.onload = onImageLoad;
                            c.after(img);
                            c.remove();
                        });
                    } else {
                        printContent();
                    }
                }, 0);
            }
        });

        vrdVm.loadInitData = (chartKey) => {
            const deferred = $q.defer();
            let initParams = vrdVm.settings.initParams;
            vrdVm.getReportParams(null, null, chartKey).then((data) => {
                ApiAdapterService[initParams[chartKey].action](initParams[chartKey], data).then((s) => {
                    deferred.resolve(s);
                    vrdVm.renderPaginatedChart(s, null, chartKey);
                })
            })
            return deferred.promise;
        }

        BroadcastService.registerCallBack('sort-chart', $scope.$id, (sortOn) => {
            let chartKey = sortOn.chartId
            sortOn.chartId && delete sortOn.chartId;

            vrdVm.getReportParams(sortOn, 'sortOn', chartKey).then((data) => {
                vrdVm.getReportData(vrdVm.settings.initParams, data, chartKey)
            })
        });
        BroadcastService.registerCallBack('chart-pagination', $scope.$id, (pagination) => {
            let chartKey = pagination.chartId
            pagination.chartId && delete pagination.chartId;
            vrdVm.getReportParams(pagination, 'pagination', chartKey).then((data) => {
                vrdVm.getReportData(vrdVm.settings.initParams, data, chartKey)
            })
        });

        vrdVm.resetToDefaults = (chartKey) => {
            const deferred = $q.defer();
            vrdVm.dataViewConfig.charts[chartKey].options.updated = _.cloneDeep(vrdVm.dataViewConfig.charts[chartKey].options.defaults);
            deferred.resolve();
            return deferred.promise;
        }

        vrdVm.getReportParams = (data, key, chartKey?) => {

            const deferred = $q.defer();
            let defaultsConfig = vrdVm.dataViewConfig.charts[chartKey].options.defaults;
            let updatedConfig = vrdVm.dataViewConfig.charts[chartKey].options.updated || _.cloneDeep(defaultsConfig);
            if (!!data && !!key) {
                if (key == 'pagination') {
                    _.set(updatedConfig, `rowsPerPage`, data.size);
                    _.set(updatedConfig, `page`, data.page);
                } else if (key == 'sortOn') {
                    _.set(updatedConfig, `sortOn`, data);
                } else if (key == 'filters') {
                    if (!updatedConfig.filter) {
                        updatedConfig.filter = {};
                    }
                    Object.assign(updatedConfig.filter, data);
                    Object.keys(updatedConfig.filter).forEach((k) => {
                        if ((Array.isArray(updatedConfig.filter[k]) && updatedConfig.filter[k].length == 0) || updatedConfig.filter[k] == null) {
                            delete updatedConfig.filter[k];
                        }
                    })
                    _.set(updatedConfig, `page`, 0);
                }
                !!data && _.set(vrdVm, `chartState[${chartKey}][${key}]`, data);
                vrdVm.dataViewConfig.charts[chartKey].options.updated = updatedConfig;
            }
            let queryParams = {
                page: updatedConfig && updatedConfig.page || 0,
                size: updatedConfig && updatedConfig.rowsPerPage || 10,
                filter: updatedConfig.filter || null,
                password: CacheService.getPassword(),
                sortOn: updatedConfig.sortOn || null
            };
            deferred.resolve(queryParams);
            return deferred.promise;
        }
        vrdVm.getSelectedText = (f) => {
            const field = (!vrdVm.isPopUpOpen ? this.fields[f] : this.fieldsCopy[f]);
            let text = "";
            if (!!field && !!field.value) {
                switch (field.type) {
                    case FieldTypeEnum.PERSON:
                        text = field.value.fullName || "";
                        break;

                    case FieldTypeEnum.SELECT:
                        text = field.value.label || "";
                        break;

                    case FieldTypeEnum.MULTI_SELECT:
                        const arr = field.value.map(a => a.label);
                        text = arr.join(", ");
                        break;
                    case FieldTypeEnum.MULTI_SELECT_PERSON:
                        const arrP = field.value.map(a => a.fullName);
                        text = arrP.join(", ");
                        break;
                    case FieldTypeEnum.DATE:
                        text = $filter('date')(field.value, "MM/dd/yyyy");
                        break;
                }
            }
            return text;
        }
        const generateReport = (deferred) => {
            if (!!vrdVm.settings && vrdVm.settings.events && !!vrdVm.settings.events.onGenerateReport) {
                vrdVm.showEmptyMsg = true;
                FieldService.onFieldEvent(vrdVm.settings.events.onGenerateReport, true).then(() => {
                    deferred.resolve();
                }).catch(() => {
                    deferred.reject();
                });
            } else {
                deferred.reject();
            }
        }
        vrdVm.generateReport = (requiredFieldValues) => {
            vrdVm.showHideFilter(false);
            const deferred = $q.defer();
            let valuesSet = false;
            if (Array.isArray(requiredFieldValues)) {
                valuesSet = true;
                for (let i = 0; i < requiredFieldValues.length; i++) {
                    if (!vrdVm.fields[requiredFieldValues[i]].value) {
                        valuesSet = valuesSet && false;
                    }
                }
            }
            if (valuesSet) {
                $timeout(() => {
                    generateReport(deferred);
                }, 100)
            } else {
                this.openGenerateReportPopup(deferred);
            }
            return deferred.promise;
        }
        vrdVm.init = () => {
            $rootScope.rootShowLoader = false;
            const loadReprt = (data, stateData) => {
                vrdVm.dataViewConfig = data.chartConfig;
                let config = new ReportMaster(data.fieldConfig);
                FieldService.init(config, this, stateData);

                this.settings = config.settings;

                this.fields = FieldService.getFields(FieldCategoryEnum.INPUT);
                FieldService.initFields(this.fields);

                this.filters = FieldService.getFields(FieldCategoryEnum.FILTER);;
                this.iFieldKeys = FieldService.getFieldKeys(this.fields);
                this.filterKeys = FieldService.getFieldKeys(this.filters);

                if (Object.keys(stateData).length == 2) {
                    $rootScope.mainShowLoader = false;
                    this.openGenerateReportPopup()
                } else if (!!stateData.generate) {
                    vrdVm.generateReport(data.fieldConfig.settings.requiredFields);
                }
                if (vrdVm.settings && vrdVm.settings.events && vrdVm.settings.events.onInit) {
                    FieldService.onFieldEvent(vrdVm.settings.events.onInit);
                }
            }
            $rootScope.mainShowLoader = true;

            if (this.params) {
                vrdVm.hasChartData = false;
                vrdVm.showEmptyMsg = true;
                const stateData = this.params;
                vrdVm.bTitle = stateData.reportName;

                if (vrdVm.extrnlModule) {
                    ExtModuleService.initializeAnalyticsMod().then((s) => {
                        loadReprt(window['config'], stateData);
                    });
                } else {
                    // get report configuration
                    if (stateData.reportId) {
                        ApiAdapterService.getReportConfiguration(stateData.reportId).then((s) => {
                            loadReprt(s, stateData);
                        }).catch((e) => {
                            throw ("report config does not fetched...")
                        });
                    } else if (stateData.sectionName) {
                        ApiAdapterService.getHistoryConfiguration(stateData.sectionName, stateData.queryParams).then((s) => {
                            loadReprt(s, stateData);
                        }).catch((e) => {
                            throw ("report config does not fetched...")
                        });
                    }
                }
            } else {
                throw ("report data required...")
            }
        }

        vrdVm.openGenerateReportPopup = (deferred) => {
            deferred = deferred || $q.defer();
            vrdVm.isPopUpOpen = true;
            this.fieldsCopy = _.cloneDeep(this.fields);
            !!vrdVm.settings.resetList && (FieldService.resetSrvcValues(vrdVm.settings.resetList));

            $uibModal.open({
                templateUrl: 'app/common/analyticsReport/components/generateReport/generateReport.html',
                controller: 'GenerateReportController as grVm',
                windowClass: 'wizard-modal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    settings: vrdVm.settings
                }
            }).result.then((fields) => {
                generateReport(deferred);
            }, (e) => {
                for (const key in vrdVm.fields) {
                    vrdVm.fields[key].value = vrdVm.fieldsCopy[key].value;
                }
                if (!!vrdVm.settings && vrdVm.settings.events && !!vrdVm.settings.events.onCancel) {
                    FieldService.onFieldEvent(vrdVm.settings.events.onCancel);
                }
                deferred.reject(e);
            }).finally(() => {
                vrdVm.isPopUpOpen = false;
            });

            return deferred.promise;
        };
        vrdVm.getMinValue = (collection, fieldName, returnType: DataTypeEnum) => {
            const deferred = $q.defer();
            let min;
            const arr = FieldService.getValueFromSource(collection);

            if (Array.isArray(arr)) {
                //process min value
                if (!!fieldName) {
                    min = _(arr).map((o) => eval("o['" + fieldName.split(".").join("']['") + "']")).min();
                }
                if (!!returnType && !!min) {
                    switch (returnType) {
                        case DataTypeEnum.DATE:
                            try {
                                min = new Date(min);
                                deferred.resolve(min);
                            } catch (e) {
                                deferred.reject();
                                console.log("Can not conver to date", e);
                            }
                            break;
                    }
                }
            }

            if (!min) {
                deferred.resolve(null);
            }

            return deferred.promise;
        }

        vrdVm.getMaxValue = (collection, fieldName, returnType: DataTypeEnum) => {
            const deferred = $q.defer();
            let max;
            const arr = FieldService.getValueFromSource(collection);

            if (Array.isArray(arr)) {
                //process max value
                if (!!fieldName) {
                    max = _(arr).map((o) => eval("o['" + fieldName.split(".").join("']['") + "']")).max();
                }
                if (!!returnType && !!max) {
                    switch (returnType) {
                        case DataTypeEnum.DATE:
                            try {
                                max = new Date(max);
                                deferred.resolve(max);
                            } catch (e) {
                                deferred.reject();
                                console.log("Can not conver to date", e);
                            }
                            break;
                    }
                }
            }

            if (!max) {
                deferred.resolve(null);
            }

            return deferred.promise;
        }

        vrdVm.resetFieldValues = (fields) => {
            const deferred = $q.defer();
            FieldService.resetFieldValues(fields).then(() => {
                deferred.resolve();
            }).catch(() => {
                deferred.reject();
            });
            return deferred.promise;
        };

        vrdVm.filterFieldData = (filter, groupFilter = null) => {
            const deferred = $q.defer();
            const handleFilter = (f) => {
                f = FieldService.getValueFromSource(f);
                f = _.clone(f);
                f = FieldService.handleParams(f);
                return f;
            }
            filter = handleFilter(filter);

            if (filter) {
                const data = _.cloneDeep(vrdVm.reportData);
                let filteredData = _.filter(data, (d) => {
                    return jsonLogic.apply(filter, d);
                });
                if (filteredData.length > 0) {
                    if (!!groupFilter) {
                        groupFilter = handleFilter(groupFilter);
                        _.each(filteredData, (fd) => {
                            fd.groupData = _.filter(fd.groupData, d => {
                                return jsonLogic.apply(groupFilter, d);
                            });
                        })
                        filteredData = _.filter(filteredData, (f) => f.groupData.length > 0);
                    }
                    if (FieldService.calculativeCols.length > 0) {
                        const service = FieldService;
                        _.each(filteredData, (row) => {
                            _.each(FieldService.calculativeCols, (col) => {
                                row[col.valueFieldName] = eval(col.data);
                            });
                        })
                    }
                }
                vrdVm.filteredData = filteredData;
                $timeout(() => {
                    vrdVm.hasChartData = (vrdVm.filteredData.length > 0);
                    BroadcastService.broadcast('resetDataView');
                }, 100);
            } else {
                vrdVm.filteredData = vrdVm.reportData;
            }
            deferred.resolve();
            return deferred.promise;
        }
        vrdVm.filterChartData = (filters) => {
            const deferred = $q.defer();
            let isEmptyObj = Object.keys(filters).every((a) => {
                return _.isEmpty(filters[a])
            })
            let areFilterEql = false
            $rootScope.mainShowLoader = true;
            let defaultFilters = _.cloneDeep(vrdVm.dataViewConfig.charts[0].options.updated.filter) || {}

            Object.keys(filters).forEach((a) => {
                if (!defaultFilters[a]) {
                    defaultFilters[a] = null;
                }
            })

            areFilterEql = !!defaultFilters && Object.keys(filters).every((a) => {
                return _.isEqual(filters[a], defaultFilters[a])
            })

            if (!areFilterEql) {
                vrdVm.dataViewConfig.charts.forEach((chart) => {
                    vrdVm.getReportParams(filters, 'filters', chart.id).then((data) => {
                        vrdVm.getReportData(vrdVm.settings.initParams, data, chart.id);
                    })
                })
            } else if (!!areFilterEql && !!isEmptyObj) {
                toastr.error("No filters are selected");
                deferred.reject("No filters are selected");
            } else if (!!areFilterEql) {
                toastr.error("filters are already applied");
                deferred.reject("filters are already applied");
            }
            deferred.resolve();
            return deferred.promise;
        }

        vrdVm.renderChart = (data, dProcess = null) => {
            $rootScope.mainShowLoader = true;
            if (!data) {
                return;
            }
            FieldService.initFields(this.filters);
            BroadcastService.broadcast('disposeChart');
            let i = 0;
            data.forEach(d => {
                //sessionTime kept for filters temporarily
                d.sessionTime = d.sessionDate;
                d.sessionDate = new Date(d.sessionDate);
                d.index = i++;
            });
            if (!!dProcess) {
                data = FieldService.processData(data, dProcess, vrdVm.dataViewConfig);
            }
            vrdVm.reportData = data;
            vrdVm.filteredData = _.clone(data);
            !vrdVm.isPopup ? vrdVm.showHideFilter(data.length > 0) : vrdVm.showHideFilter(false)
            if (data.length > 0) {
                vrdVm.hasChartData = true;
                BroadcastService.broadcast('initChart');
            } else {
                vrdVm.hasChartData = false;
                $rootScope.mainShowLoader = false;
            }
        };


        vrdVm.renderPaginatedChart = (data, dProcess = null, chartIndex = 0, type = 'INIT') => {
            let reportData = data;

            $rootScope.mainShowLoader = true;
            if (!reportData) {
                return [];
            }
            if (data.number != undefined || data.number != null) {
                data.number++
            }
            if (type === "INIT") {
                FieldService.initFields(this.filters);
            }
            let i = 0;
            reportData.content.forEach(d => {
                //sessionTime kept for filters temporarily
                d.sessionTime = d.sessionDate;
                d.sessionDate = new Date(d.sessionDate);
                d.index = i++;
            });
            if (!!dProcess) {
                let processedData = FieldService.processData(reportData.content, dProcess, vrdVm.dataViewConfig);
                reportData.content = processedData
            }

            if (type === "INIT") {
                BroadcastService.broadcast('disposeChart');
                if (!vrdVm.reportData) { vrdVm.reportData = []; }
                vrdVm.reportData[chartIndex] = reportData;
            }
            if (!vrdVm.hasReportData) { vrdVm.hasReportData = []; }
            if (!vrdVm.filteredData) { vrdVm.filteredData = []; }
            vrdVm.filteredData[chartIndex] = _.clone(reportData);

            !vrdVm.isPopup ? vrdVm.showHideFilter(vrdVm.reportData[chartIndex].content.length > 0) : vrdVm.showHideFilter(false)
            vrdVm.hasReportData[chartIndex] = (reportData.content.length > 0);
            if (!!vrdVm.hasReportData[chartIndex]) {
                if (type === "INIT") {
                    $timeout(() => {
                        BroadcastService.broadcast('initChart');
                    }, 100);

                } else if (type = "UPDATE") {
                    $timeout(() => {
                        BroadcastService.broadcast('resetDataView');
                    }, 100);
                }


            } else {
                $rootScope.mainShowLoader = false;
            }
        }
        vrdVm.getReportData = (initParams, queryParams, index) => {
            ApiAdapterService[initParams[index].action](initParams[index], queryParams).then((s) => {
                vrdVm.renderPaginatedChart(s, null, index, "UPDATE")
            })
        }

        vrdVm.showHideFilter = (flag) => {
            this.showFilter = flag;
            if ($('body').hasClass('safari') || $('body').hasClass('ipad')) {
                let height = "100%";
                if (flag && window.innerWidth < 960) {
                    height = $('#chartMsgCntnr').height() + 'px';
                }
                $timeout(() => {
                    $('#reportFilter').css('height', height);
                }, 100);
            }
        }

        $timeout(() => {
            $('body').addClass('vfh');
            print = $rootScope.print;
            window.print = function () {
                vrdVm.isPrintInProgress = true;
                vrdVm.loadedChartCount = 0;
                BroadcastService.broadcast('print-started');
            }
        }, 200);

        const resizeFunc = () => {
            if (window.innerWidth > 959 && !vrdVm.isPopup) {
                vrdVm.showHideFilter(true);
            }
            subsribeScroll();
        };
        $(window).on('resize', resizeFunc);

        function subsribeScroll() {
            if (vrdVm.extrnlModule) {
                $('#rplayground, #filterIcon').addClass('stickytop');
            }
            $('.emain').on('scroll', function () {
                $('md-table-container.chart').click();//to hide extra tooltip
                if (!vrdVm.extrnlModule) {
                    if ($('.emain').scrollTop() >= 105) {
                        $('#rplayground, #filterIcon').addClass('stickytop');
                    }
                    else {
                        $('#rplayground, #filterIcon').removeClass('stickytop');
                    }
                }
            });
        }

        function unSubscribeScroll() {
            $('.emain').off('scroll');
        }

        subsribeScroll();
        $scope.$on('$destroy', function () {
            $('body').removeClass('vfh');
            $(window).off('resize', resizeFunc);
            unSubscribeScroll();
            window.print = print;
            $('#printContainer').children().remove();
            BroadcastService.removeCallBack('chart-data-loaded', $scope.$id);
            BroadcastService.removeCallBack('sort-chart', $scope.$id);
            BroadcastService.removeCallBack('chart-pagination', $scope.$id);
        });
    }
}
function ViewReport(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/analyticsReport/components/viewReport/view-report.directive.html',
        replace: true,
        controller: EcvViewReport,
        controllerAs: 'vrdVm',
        scope: true,
        bindToController: {
            'extrnlModule': "=",
            'params': "=",
            'subjectId': "=?",
            'isPopup': "=",
            'ecvId': "="
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvViewReport): void => {
            controller.init();
        }
    }
}

angular.module('eCareVault.common.analyticsReport').directive('ecvViewReport', ViewReport);
